import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";

import { Pattern } from "@dffedb/util";

export class FlyttemeddelelseFaktureringsadresseFormBuilder {
    public static opretForm(): UntypedFormGroup {
        const formBuilder = new UntypedFormBuilder();
        return formBuilder.group({
            navn: [null, Validators.maxLength(30)],
            adresse: formBuilder.group({
                vejnavn: ["", Validators.maxLength(30)],
                postnr: [null, Validators.pattern(Pattern.postNr)],
                by: [null]
            })
        });
    }
}
